var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.25 35.0014C64.2497 41.1783 62.2939 47.1966 58.663 52.1937C55.0321 57.1908 49.9125 60.9101 44.0378 62.8187C38.1632 64.7273 31.8351 64.7271 25.9606 62.8182C20.086 60.9093 14.9666 57.1896 11.336 52.1924C7.70537 47.1951 5.74996 41.1767 5.75 34.9998C5.75004 28.8229 7.70554 22.8045 11.3362 17.8073C14.9669 12.8101 20.0864 9.09051 25.961 7.18168C31.8356 5.27286 38.1636 5.27277 44.0383 7.18144",
    stroke: "#00D1D2",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.a3d027c4.svg";
export { ForwardRef as ReactComponent };